<!--
  ~ Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->

<og-highchart [options]="options"></og-highchart>
